<template>
  <div class="mt-3">
    <v-card>
      <v-card-title>
        <span>{{ sectionLabel }}</span>
        <v-spacer />
        <v-btn color="primary" dark small @click.native="saveForm()">Add</v-btn>
      </v-card-title>
      <v-card-text class="p-n">
        <v-alert type="info" border="left" dense class="mb-2" v-if="sectionInfoBox">
          {{sectionInfoBox}}
        </v-alert>
        <v-row dense class="customCollapseHeader">
          <v-col cols="6" sm="4">From Date</v-col>
          <v-col cols="6" sm="4">To Date</v-col>
          <v-col class="d-none d-sm-flex" sm="4">Stay Location</v-col>
        </v-row>
        <el-collapse v-model="activeNames" accordion>
          <el-collapse-item :name="i+1" v-for="(form,i) in items" :key="i">
            <template slot="title">
              <div class="customHead">
                <v-row dense>
                  <v-col cols="6" sm="4"><el-tag type="primary" v-if="form.from_date">{{ form.from_date | day }}</el-tag></v-col>
                  <v-col cols="6" sm="4"><el-tag type="success" v-if="form.to_date">{{ form.to_date | day }}</el-tag></v-col>
                  <v-col class="d-none d-sm-flex" sm="4"><div class="pl-2 pr-2">{{ form.stay_location }}</div></v-col>
                </v-row>
              </div>
            </template>
            <el-form :model="form" ref="form" label-position="top">
              <v-row dense>
                <v-col cols="12" sm="6" md="4">
                  <el-form-item label="From:" prop="from_date">
                    <el-date-picker :id="'from_date' + form.id" :picker-options="datePickerOptions" @change="handleAutoSave(i, form)" value-format="yyyy-MM-dd" v-model="form.from_date" v-on:click.native="checkDate($event)" style="width: 100%;"></el-date-picker>
                  </el-form-item>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <el-form-item label="To:" prop="to_date">
                    <el-date-picker :id="'to_date' + form.id" :picker-options="datePickerOptions" @change="handleAutoSave(i, form)" value-format="yyyy-MM-dd" v-model="form.to_date" v-on:click.native="checkDate($event)" style="width: 100%;"></el-date-picker>
                  </el-form-item>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <el-form-item label="Stay Location" prop="stay_location">
                    <el-input :id="'stay_location' + form.id" @change="handleAutoSave(i, form)" v-model="form.stay_location" style="width: 100%" />
                  </el-form-item>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <el-form-item label="Who traveled" prop="who_traveled">
                    <el-input :id="'who_traveled' + form.id" @change="handleAutoSave(i, form)" v-model="form.who_traveled" style="width: 100%" />
                  </el-form-item>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <el-form-item prop="stay_together">
                    <el-checkbox :id="'stay_together' + form.id" @change="handleAutoSave(i, form)" v-model="form.stay_together">Stay Together</el-checkbox>
                  </el-form-item>
                </v-col>
                <v-col cols="12">
                  <v-btn :loading="loading" :disabled="loading" color="primary" small @click.native="handleAutoSave(i,form)">
                    {{ $t('global.save') }}
                  </v-btn>
                  <v-btn color="error" small @click.native="deleteOpen(form,i)">Delete</v-btn>
                </v-col>
              </v-row>
            </el-form>
          </el-collapse-item>
        </el-collapse>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import autosave from '@/mixins/autosave.js'

export default {
  mixins: [autosave],
  props: {
    sectionId: {
      type: String
    },
    layout: {
      type: String
    },
    sectionLabel: {
      type: String
    },
    sectionInfoBox: {
      type: String
    },
    memberUID: {
      type: String,
      required: true
    },
    memberID: {
      type: String,
      required: true
    },
    datas: {
      type: Array
    }
  },
  data() {
    return {
      edit: false,
      formItem: {
        application_id: this.$route.params.id,
        member_uid: this.memberUID,
        member_id: parseFloat(this.memberID),
        who_traveled: null,
        from_date: null,
        to_date: null,
        stay_location: null,
        stay_together: null
      },
      activeNames: -1,
      url: 'imms_table/application_sponsorship_visit_history',
      fields: ['who_traveled', 'from_date', 'to_date', 'stay_location', 'stay_together'],
      items: [],
      loading: false
    }
  },
  watch: {
    memberUID: function() {
      this.fetchData()
    }
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    fetchData() {
      this.$Progress.start()
      var url = `table/application_sponsorship_visit_history?filter=member_uid=${this.memberUID}&order=from_date DESC, to_date DESC`
      this.$store.dispatch('store/get', url)
        .then(response => {
          this.items = response.resource
          if (this.datas !== undefined) {
            this.checkItemsFields(response.resource, this.datas, this.sectionId)
          }
          this.$Progress.finish()
        })
        .catch(err => {
          this.$Progress.fail()
        })
    },
    nodeClear() {
      this.formItem = {
        application_id: this.$route.params.id,
        member_uid: this.memberUID,
        member_id: parseFloat(this.memberID),
        who_traveled: null,
        from_date: null,
        to_date: null,
        stay_location: null,
        stay_together: null
      }
      this.edit = false
    },
    saveForm() {
      this.nodeClear()
      this.edit = false
      this.items.push(this.formItem)
      var len = this.items.length
      this.activeNames = len
    },
    resetForm() {
      this.$refs.form.resetFields()
      this.nodeClear()
    }
  }
}
</script>
